import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Question } from './question';
import { BadInputError, Result, UniqueEntityID } from '@digibricks/core';
import { Answer } from '../answer';
import { CorrectAnswer, MultipleChoiceCorrectAnswer } from '../correct-answers';
import { QuestionType } from '../question-type';
import { SingleChoiceQuestion } from './single-choice-question';
import { FillInBlankQuestion } from './fill-in-blank-question';
import { EssayQuestion } from './essay-question';
import { MatchingQuestion } from './matching-question';
import { SpeakingQuestion } from './speaking-question';
export var MultipleChoiceQuestion = /*#__PURE__*/function (_Question) {
  _inherits(MultipleChoiceQuestion, _Question);

  var _super = _createSuper(MultipleChoiceQuestion);

  function MultipleChoiceQuestion() {
    _classCallCheck(this, MultipleChoiceQuestion);

    return _super.apply(this, arguments);
  }

  _createClass(MultipleChoiceQuestion, [{
    key: "answers",
    get: function get() {
      return this.props.answers;
    }
  }, {
    key: "correctAnswers",
    get: function get() {
      return this.props.correctAnswers;
    }
  }, {
    key: "cloneExtendedProps",
    value: function cloneExtendedProps(question, newQuestionProps) {
      var multipleChoiceQuestion = question;

      switch (newQuestionProps.type) {
        case QuestionType.SingleChoice:
          {
            var singleChoiceQuestionProps = newQuestionProps;
            var answers = multipleChoiceQuestion.answers,
                correctAnswers = multipleChoiceQuestion.correctAnswers;
            singleChoiceQuestionProps.answers = answers.map(function (a) {
              return a.clone();
            });

            if (correctAnswers.length > 0) {
              var newCorrectAnswers = [correctAnswers[0].clone()];
              singleChoiceQuestionProps.correctAnswers = newCorrectAnswers;
            } else {
              var _singleChoiceQuestion = _slicedToArray(singleChoiceQuestionProps.answers, 1),
                  firstAnswer = _singleChoiceQuestion[0];

              var _correctAnswers = [CorrectAnswer.create({
                answerId: firstAnswer.id.toString()
              }).getValue()];
              singleChoiceQuestionProps.correctAnswers = _correctAnswers.map(function (c) {
                return c.clone();
              });
            }

            return SingleChoiceQuestion.create(singleChoiceQuestionProps);
          }

        case QuestionType.FillInBlank:
          return FillInBlankQuestion.createDefault(newQuestionProps);

        case QuestionType.Essay:
          return EssayQuestion.create(newQuestionProps);

        case QuestionType.Speaking:
          return SpeakingQuestion.createDefault(newQuestionProps);

        case QuestionType.Matching:
          {
            return MatchingQuestion.createDefault(newQuestionProps);
          }

        case QuestionType.MultipleChoice:
          {
            var multipleChoiceQuestionProps = newQuestionProps;
            multipleChoiceQuestionProps.answers = multipleChoiceQuestion.answers.map(function (a) {
              return a.clone();
            });
            multipleChoiceQuestionProps.correctAnswers = multipleChoiceQuestion.correctAnswers.map(function (c) {
              return c.clone();
            });
            return MultipleChoiceQuestion.create(multipleChoiceQuestionProps);
          }
      }
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(MultipleChoiceQuestion.prototype), "toJsonObject", this).call(this)), {}, {
        answers: this.answers.map(function (a) {
          return a.toJsonObject();
        }),
        correctAnswers: this.correctAnswers.map(function (c) {
          return c.toJsonObject();
        })
      });
    }
  }, {
    key: "addNewAnswer",
    value: function addNewAnswer(answer) {
      this.props.answers = [].concat(_toConsumableArray(this.props.answers), [answer]);
      return Result.ok();
    }
  }, {
    key: "deleteAnswer",
    value: function deleteAnswer(answerId) {
      var onlyOneAnswer = this.answers.length === 1;

      if (onlyOneAnswer) {
        return new BadInputError('The question should have at least one answer');
      }

      var answersUpdate = this.props.answers.filter(function (answer) {
        return answer.id.toString() !== answerId;
      });
      var deletedCorrectAnswerResult = this.deleteCorrectAnswer(answerId);

      if (deletedCorrectAnswerResult.isFailure) {
        return deletedCorrectAnswerResult;
      }

      this.props.answers = _toConsumableArray(answersUpdate);
      var newCorrectAnswers = CorrectAnswer.create({
        answerId: this.props.answers[0].id.toString()
      }).getValue();
      this.props.correctAnswers = [newCorrectAnswers];
      return Result.ok();
    }
  }, {
    key: "deleteCorrectAnswer",
    value: function deleteCorrectAnswer(answerId) {
      var answersUpdate = this.props.correctAnswers.filter(function (correctAnswer) {
        return correctAnswer.answerId.toString() !== answerId;
      });
      this.props.correctAnswers = _toConsumableArray(answersUpdate);
      return Result.ok();
    }
  }, {
    key: "updateAnswer",
    value: function updateAnswer(answer) {
      this.props.answers.splice(this.props.answers.indexOf(answer), 1, answer);
      return Result.ok();
    }
  }, {
    key: "updateCorrectAnswer",
    value: function updateCorrectAnswer(answerIds) {
      var correctAnswers = answerIds.map(function (answerId) {
        return MultipleChoiceCorrectAnswer.create({
          id: new UniqueEntityID().toString(),
          answerId: answerId
        }).getValue();
      });
      this.props.correctAnswers = correctAnswers;
      return Result.ok();
    }
  }, {
    key: "updateAnswers",
    value: function updateAnswers(answers) {
      this.props.answers = answers;
      return Result.ok();
    }
  }, {
    key: "updateCorrectAnswers",
    value: function updateCorrectAnswers(correctAnswers) {
      var answerIds = correctAnswers.map(function (ca) {
        return ca.answerId;
      });
      var isNotValidAnswers = this.answers.filter(function (a) {
        return answerIds.includes(a.id.toString());
      }).length !== answerIds.length;

      if (isNotValidAnswers) {
        return new BadInputError('The Correct answers are not existed in answers');
      }

      this.props.correctAnswers = correctAnswers;
      return Result.ok();
    }
  }, {
    key: "toJsonV2",
    value: function toJsonV2() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(MultipleChoiceQuestion.prototype), "toBaseJson", this).call(this)), {}, {
        answers: this.answers.map(function (a) {
          return a.toJsonObject();
        }),
        correctAnswers: this.correctAnswers.map(function (a) {
          return a.toJsonObject();
        })
      });
    }
  }], [{
    key: "create",
    value: function create(props) {
      var _props$answers, _props$correctAnswers;

      var basePropsOrError = _get(_getPrototypeOf(MultipleChoiceQuestion), "createBaseProps", this).call(this, props);

      if (basePropsOrError.isFailure) {
        return Result.fail(basePropsOrError.error);
      }

      var resultOrError = this.validate(props);

      if (resultOrError.isFailure) {
        return Result.fail(resultOrError.error);
      }

      var defaultProps = _objectSpread(_objectSpread(_objectSpread({}, basePropsOrError.getValue()), props), {}, {
        type: QuestionType.MultipleChoice,
        answers: (_props$answers = props.answers) !== null && _props$answers !== void 0 ? _props$answers : [],
        correctAnswers: (_props$correctAnswers = props.correctAnswers) !== null && _props$correctAnswers !== void 0 ? _props$correctAnswers : []
      });

      return Result.ok(new MultipleChoiceQuestion(defaultProps, new UniqueEntityID(props.id)));
    }
  }, {
    key: "createDefault",
    value: function createDefault(props) {
      var basePropsOrError = _get(_getPrototypeOf(MultipleChoiceQuestion), "createBaseProps", this).call(this, props);

      if (basePropsOrError.isFailure) {
        return Result.fail(basePropsOrError.error);
      }

      var firstAnswer = Answer.create({
        description: ''
      }).getValue();
      var secondAnswer = Answer.create({
        description: ''
      }).getValue();
      var answers = [firstAnswer, secondAnswer];
      var correctAnswers = [CorrectAnswer.create({
        answerId: firstAnswer.id.toString()
      }).getValue()];
      return MultipleChoiceQuestion.create(_objectSpread(_objectSpread({}, basePropsOrError.getValue()), {}, {
        answers: answers,
        correctAnswers: correctAnswers
      }));
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      try {
        var answers = data.answers,
            correctAnswers = data.correctAnswers;

        var basePropsOrError = _get(_getPrototypeOf(MultipleChoiceQuestion), "fromJsonBase", this).call(this, data);

        if (basePropsOrError.isFailure) {
          return Result.fail(basePropsOrError.error);
        }

        var answerResultCombine = answers.map(function (a) {
          return Answer.fromJson(a);
        });
        var answerPropsOrError = Result.combineArray(answerResultCombine);

        if (answerPropsOrError.isFailure) {
          return Result.fail(answerPropsOrError.error);
        }

        var correctAnswerProps = correctAnswers ? correctAnswers.map(function (c) {
          return MultipleChoiceCorrectAnswer.create({
            id: c.id,
            answerId: c.answerId
          }).getValue();
        }) : [];
        return this.create(_objectSpread(_objectSpread({}, basePropsOrError.getValue()), {}, {
          type: QuestionType.MultipleChoice,
          answers: answerPropsOrError.getValue(),
          correctAnswers: correctAnswerProps
        }));
      } catch (error) {
        return Result.fail(error);
      }
    }
  }]);

  return MultipleChoiceQuestion;
}(Question);